import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Box, Chip } from "@mui/material";
import { styled } from "@mui/material/styles";

export const ChangeCell = styled(Box)(() => ({
  position: "relative",
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export const ChangeChip = styled(Chip)(() => ({
  position: "absolute",
  left: "calc(50% + 22px)",

  ".MuiChip-label": {
    paddingLeft: "6px",
    fontSize: "12px",
  },

  svg: {
    width: "12px",
  },
}));

export const Icon = styled(InfoOutlinedIcon)`
  position: absolute;
  left: -4px;
  top: 50%;
  transform: translate(-50%, -50%);
`;
